import { render, staticRenderFns } from "./direct.vue?vue&type=template&id=05595abe&"
import script from "./direct.vue?vue&type=script&lang=js&"
export * from "./direct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports